import {NotificationService} from "../../services/NotificationService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {AssetService} from "../../services/AssetService";
import {ApplicationSetting} from "../../entities/ApplicationSetting";

export class CmdCenterEditOptionsModel {
    applicationSetting:ApplicationSetting;
    distances:string[] = ["Feet", "Meters"]
    static $inject = ['$q','AssetService','ApplicationSettingService','NotificationService'];
    constructor(public $q:ng.IQService,
                public assetService:AssetService,
                public applicationSettingService:ApplicationSettingService,
                public notificationService:NotificationService)
    {
    }
    init() {
        this.applicationSettingService.getCached()
            .then((data)=> {
                this.applicationSetting = data;
            });
    }
    clearLocationData(){
        this.assetService.clearAllRtlsInformation();
        this.notificationService.notify("All RTLS information cleared successfully.")
    }
    save(){
        this.applicationSettingService.update(this.applicationSetting)
        .then((data)=>{
          this.notificationService.notify("Configuration changes updated successfully. Please logout first to see changes.");
        }).catch((exc)=>{
          this.notificationService.notifyError("Error saving configuration info:",exc);
        });

    }
}
